import { z } from 'zod4';

import { isoDatetimeToDate } from './dates';

export const SpotlightStatus = z.enum(['pending', 'processing', 'completed', 'failed']);

export const EmployeeSpotlightSection = z.object({
	intro: z.string(),
	title: z.string(),
	textHtml: z.string(),
	supportingEvidence: z.array(z.string()),
	type: z.string(), // Used for display label, not strictly validated
});

export type EmployeeSpotlightSection = z.infer<typeof EmployeeSpotlightSection>;

export const EmployeeSpotlight = z.object({
	id: z.string(),
	userId: z.string(),
	companyId: z.string(),
	generatedByUserId: z.string().nullable(),
	startTime: isoDatetimeToDate,
	endTime: isoDatetimeToDate,
	status: SpotlightStatus,
	generationStartedAt: isoDatetimeToDate.nullable(),
	generationCompletedAt: isoDatetimeToDate.nullable(),
	generationError: z.string().nullable(),
	sections: z.array(EmployeeSpotlightSection).default([]),
	createdAt: isoDatetimeToDate,
	updatedAt: isoDatetimeToDate,
});

export type EmployeeSpotlight = z.infer<typeof EmployeeSpotlight>;
